import { render, staticRenderFns } from "./UIDemandDetail.vue?vue&type=template&id=11d19fc1&scoped=true&"
import script from "./UIDemandDetail.vue?vue&type=script&lang=js&"
export * from "./UIDemandDetail.vue?vue&type=script&lang=js&"
import style0 from "./UIDemandDetail.vue?vue&type=style&index=0&id=11d19fc1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d19fc1",
  null
  
)

export default component.exports